<!-- Container Type -->
<div *ngIf="getPanelType() === 'container'" class="ly-sp-m-top" [ngClass]="getStyleClass()">
    <ng-container #target></ng-container>
</div>

<!-- Action Type -->
<div *ngIf="getPanelType() === 'action'" class="panel-action-general-container"
    [ngClass]="{
        'single-column-small': isSmallSize,
        'single-column-medium': isMediumSize,
        'single-row-extra-small': isExtraSmall
    }">
    <div *ngIf="getPanelType() === 'action'" class="panel-action-container" [ngStyle]="getStyleTextAlign()">
        <div *ngIf="getTitle()" class="action-title-container">
            <div class="th-text-main action-title bs-h2">{{getTitle()}}</div>
        </div>
        <div *ngIf="getDescription()" class="action-description-container">
            <div class="action-description bs-paragraph th-text-gray-paragraphs">{{getDescription()}}</div>
        </div>
        <div class="action-child-container"> 
            <ng-container #target></ng-container>
        </div>
    </div>
</div>
